// This file was auto-generated by __GENERATE_CHAIN_PRESETS__.js. Do not edit manually.

import { zksync as _zksync } from 'viem/chains'
import { createCommon } from '../createCommon.js'

/**
 * Creates a common configuration for the zksync chain.
 * @type {import('../Common.js').Common}
 * @description
 * Chain ID: 324
 * Chain Name: ZKsync Era
 * Default Block Explorer: https://era.zksync.network/
 * Default RPC URL: https://mainnet.era.zksync.io
 * @example
 * import { createMemoryClient } from 'tevm'
 * import { zksync } from 'tevm/common'
 * import { http } from 'tevm'
 *
 * const client = createMemoryClient({
 *   common: zksync,
 *   fork: {
 *     transport: http({ url: 'https://example.com' })({})
 *   },
 * })
 */
export const zksync = createCommon({
	..._zksync,
	loggingLevel: 'warn',
	eips: [],
	hardfork: 'prague',
})
